import { RichText } from '@graphcms/rich-text-react-renderer';
import { Grid, GridRow, GridItem } from './../Grid';
import { Title, Text } from './../Typography';
import { CurveDesktop, CurveMobile } from '../Icons/icons';
import { DescriptionWrapper, TitleWrapper, RichTextWrapper } from '../IntroText/styles';
import { ShortHeroWrapper } from './styles';

export function ShortHero(data: { data: { superTitle: string; title: string; description: string; } }) {
  const { superTitle, title, description } = data?.data;
  return (
    <div>
      <CurveMobile className="md:hidden" />
      <CurveDesktop className="hidden md:block" />
      <ShortHeroWrapper>
        <Grid>
          <GridRow columns={16}>
            <GridItem colStart={4} colSpan={10}>
              <DescriptionWrapper data-test="description-wrapper">
                {superTitle && (
                  <Text data-test="text-super" tag="sup" type="lead">
                    {superTitle}
                  </Text>
                )}
                {title && (
                  <TitleWrapper>
                    <Title data-test="title" tag={'h1'} type="lg">
                      {title}
                    </Title>
                  </TitleWrapper>
                )}
                {description && (
                  <Text data-test="text-description" tag="p" type="lg">
                    {description}
                  </Text>
                )}
              </DescriptionWrapper>
            </GridItem>
          </GridRow>
        </Grid>
      </ShortHeroWrapper>
    </div>
  );
}
